import React from 'react'
import Modal from 'components/Modal/v2'
import type { ConnectorProps as ModalProps } from 'containers/Modal'
import ModalConnector from 'containers/Modal'
import ContactModal from './Modal'

const Component = (
  props: ModalProps & Record<string, any>
): React.ReactElement<React.ComponentProps<any>, any> => {
  const { closeModal, openModal, type } = props
  const MODAL_NAME = `tradeContactModal_${type}`
  return (
    <div data-type='contact-us'>
      <div
        data-link='modal'
        onClick={() => openModal(`tradeContactModal_${type}`)}
        onKeyDown={() => openModal(`tradeContactModal_${type}`)}
        role='button'
        tabIndex='0'
      >
        <button type='button' data-type='contact-us-button'>
          Contact Us
        </button>
      </div>
      <Modal name={MODAL_NAME}>
        <ContactModal closeModal={closeModal} />
      </Modal>
    </div>
  )
}

export default ModalConnector(Component)